import React from 'react';
import {PageTitle} from '../../../_metronic/layout/core';
import {Link, useParams} from 'react-router-dom'


const SalesPediaPageVegan = () => {
  return (
<>
  <PageTitle breadcrumbs={[{title:"Anasayfa",path:"/",isActive:true,isSeparator:false},{title:"Vegan Ürünler",path:"/",isActive:true,isSeparator:true}]}>{"Vegan Ürünler"}</PageTitle>
    <div className="card mb-5 mb-xl-10">
      <div className="card mb-0">
        <div className="card-body mb-0">
          <div className="mb-0">
            <h3 className="text-black mb-7">Vegan Ürünler</h3>
            <div className="separator separator-dashed mb-9"></div>
            <div className="row">
              <div className="col-md-12">
                <div className="h-100 d-flex flex-column justify-content-between pe-lg-6 mb-lg-0 mb-10">
                  <div className="mb-3">
                    <div className="bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-350px"
                         style={{backgroundImage:"url('document/vegan/Screenshot_1.png')"}}></div>

               {/*  <iframe className="embed-responsive-item card-rounded h-375px w-100"
                            src="https://www.youtube.com/embed/uUkKrS6UsFw" ></iframe>*/}
                  </div>
                  <div className="mb-5">
                    <a href="#" className="fs-2 text-dark fw-bolder text-hover-primary text-dark lh-base">Vegan Ürünler
                      <br/>Ürün Testleri</a>
                    <div className="fw-bold fs-5 text-gray-600 text-dark mt-4">
                      <p>
                      Veganizm, ya da vegan yaşam şekli, mümkün ve uygulanabilir olduğu ölçüde,
                      yiyecek, giyecek veya başka herhangi
                      bir amaçla hayvanlara yönelik her türlü  sömürü ve zulümden uzak durmaya çalışan bir felsefe ve yaşam şeklidir.
                      Bu  görüşü benimseyen kişiler, hayvanların, insanların ve çevrenin yararına  hayvanların kullanılmadığı alternatiflerin kullanılmasından yanadır. Diyet olarak  bakıldığında da tamamen veya kısmen hayvanlardan elde edilen tüm ürünlerden  vazgeçme uygulamasını ifade etmektedir.
                      </p>
                        <p>
                      Bugün vegan yaşam şeklini benimsemenin birçok yolu bulunmaktadır. Ama  hepsinin ortak özelliği, balık, kabuklu deniz ürünleri ve böcekler dahil et  yememek, süt ürünleri kullanmamak, yumurta ve bal gibi tüm hayvansal  gıdalardan kaçınmaktır. Aynı zamanda hayvansal kaynaklı ürünlerden, hayvanlar  üzerinde test edilen ürünlerden ve hayvanları eğlence için kullanan yerlerden  kaçınmaktır.
                       </p>
                      1940’lı yılların sonlarına doğru ilk olarak hayvanların insanlar tarafından  sömürülmesinden kurtulma düşüncesi ile başlatılan bu hareket, çok geçmeden  hayvanların, insanlar tarafından bir ürün, iş, avlanma ya da eğelnce amaçlı  kullanılmasına son verilmesi düşüncesine dönüşmüştür.
<p>
                      Aslında veganlar, hayvansal ürünler dışında çok zengin yiyecek ve tatlardan  oluşan yepyeni bir dünya bulmaktadır. Vegan diyet zengin çeşitlilik  göstermektedir ve her türlü meyva, sebze, kuruyemiş, tahıl, tohum ve bakliyat  içermektedir ve bunlarla sonsuz kombinasyonlar yaplabilmektedir. Hamur  işlerinden pizzaya kadar en sevilen şeyler, bitki bazlı malzemelerle yapılmışsa,  vegan bir diyet için bu çok uygundur.
</p>
                      Elbette konu sadece diyetle ilgili değildir. Vegan yaşam şeklini uygulayan  insanlar, hayvanları herhangi bir amaçla istismar etmekten kaçınmaktadır. Bugün  giyeceklerden aksesuarlara, hatta banyo ve makyaj malzemelerine kadar,  hayvan ürünleri ve hayvanlar üzerinde test edilen ürünler, her yerde  bulunmaktadır. Tahminlere göre, vegan markasında kayıtlı 50 bin civarında  alternatif ürün bulunmaktadır.

                      İlaçlar konusu biraz hassastır. Bugün neredeyse tüm ilaçlar, insan kullanımı için  güvenli olduğunu kanıtlamak üzere hayvanlar üzerinde test edilmektedir. Ancak  ilaçlardan kaçınmak, bu nedenle sağlığı kaybetmekten daha önemli değildir. Bu bakımdan mümkün olduğunda jelatin veya laktoz gibi hayvansal ürünler  içermeyen ilaçlar talep edilebilir, ancak hepten vazgeçilemez. Günümüzde  hayvanlar üzerinde test yapmayan çok sayıda kurum bulunmaktadır.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-12">
        <div className="card card-flush h-lg-100">
          <div className="card-header">
            <div className="card-title flex-column">
              <h3 className="fw-bolder mb-1">Dosyalar</h3>
            </div>
          </div>
          <div className='col-md-6'>
          <div className="card-body mb-0">
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center mb-0">
                <div className="symbol symbol-30px me-5">
                  <img alt="Icon" src={'media/svg/files/pdf.svg'}/>
                </div>
                <div className="fw-bold">
                  <Link className="fs-6 fw-bolder text-dark text-hover-primary" to={'/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf'}>Metro Promosyonlar - Bitkisel ve Vegan</Link>
                  <div className="text-gray-400">2 days ago
                    <a href="#">Karina Clark</a></div>
                </div>
                <button type="button"
                        className="btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary ms-auto"
                        data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-flip="top-end">
                  <span className="svg-icon svg-icon-3">
																<img alt={"icon"} src={"media/icons/duotone/Communication/Share.svg"}/>
									</span>
                </button>
              </div>
            </div>
          </div>
          </div>
          <div className='col-md-6'>
            <div className="card-body mb-0">
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center mb-0">
                  <div className="symbol symbol-30px me-5">
                    <img alt="Icon" src={'media/svg/files/excel.svg'}/>
                  </div>
                  <div className="fw-bold">
                    <a className="fs-6 fw-bolder text-dark text-hover-primary" href={process.env.PUBLIC_URL +'/document/vegan/Vegan ürünler listesi-260821.xlsx'}>Vegan ürünler listesi</a>
                    <div className="text-gray-400">2 days ago
                      <a href="#">Karina Clark</a></div>
                  </div>
                  <button type="button"
                          className="btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary ms-auto"
                          data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-flip="top-end">
                  <span className="svg-icon svg-icon-3">
																<img alt={"icon"} src={"media/icons/duotone/Communication/Share.svg"}/>
									</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </div>
  <div className="card ">
    <div className='row'>
      <div className='col-md-12'>
    <div className="overflow-auto pb-5">
      <div className="d-flex align-items-center border border-dashed border-gray-300 rounded min-w-700px p-7">

        <div className="overlay me-10">

          <div className="overlay-wrapper">
            <img alt="img" className="rounded w-200px" src="document/vegan/13646608924028243068_120x170.jpg"/>
          </div>

          <div className="overlay-layer bg-dark bg-opacity-10 rounded">
            <Link to="/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf" className="btn btn-sm btn-primary btn-shadow">Göster</Link>
          </div>

        </div>

        <div className="overlay me-10">

          <div className="overlay-wrapper">
            <img alt="img" className="rounded w-200px" src="document/vegan/15608651385981981280_120x170.jpg"/>
          </div>

          <div className="overlay-layer bg-dark bg-opacity-10 rounded">
            <Link to="/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf" className="btn btn-sm btn-primary btn-shadow">Göster</Link>
          </div>

        </div>

        <div className="overlay me-10">

          <div className="overlay-wrapper">
            <img alt="img" className="rounded w-200px" src="document/vegan/17783925685203395035_120x170.jpg"/>
          </div>

          <div className="overlay-layer bg-dark bg-opacity-10 rounded">
            <Link to="/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf" className="btn btn-sm btn-primary btn-shadow">Göster</Link>
          </div>

        </div>
        <div className="overlay me-10">

          <div className="overlay-wrapper">
            <img alt="img" className="rounded w-200px" src="document/vegan/2461248193699964375_120x170.jpg"/>
          </div>

          <div className="overlay-layer bg-dark bg-opacity-10 rounded">
            <Link to="/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf" className="btn btn-sm btn-primary btn-shadow">Göster</Link>
          </div>

        </div>
        <div className="overlay me-10">

          <div className="overlay-wrapper">
            <img alt="img" className="rounded w-200px" src="document/vegan/4458905170579259940_120x170.jpg"/>
          </div>

          <div className="overlay-layer bg-dark bg-opacity-10 rounded">
            <Link to="/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf" className="btn btn-sm btn-primary btn-shadow">Göster</Link>
          </div>

        </div>
        <div className="overlay me-10">

          <div className="overlay-wrapper">
            <img alt="img" className="rounded w-200px" src="document/vegan/9701550033750167221_120x170.jpg"/>
          </div>

          <div className="overlay-layer bg-dark bg-opacity-10 rounded">
            <Link to="/salespediafilepage/Metro Promosyonlar - Bitkisel ve Vegan.pdf" className="btn btn-sm btn-primary btn-shadow">Göster</Link>
          </div>

        </div>

      </div>
    </div></div>
    </div>
  </div>
</>
  )
}

export default SalesPediaPageVegan